import { toast } from 'react-toastify';
import appApi from '../../../../../../api/app-api';
import globalUserPage from '../../../../../../stores/global-user-page';
import { displayErrorText } from '../../../../../../api/errors/api-error-codes';
import { UserSummaryType } from '../../../../../../api/types/user/user-summary.type';

export const reduceInstallmentPaymentBankTransferOperation = async (
  user: UserSummaryType,
  installmentPlanId: number,
  installmentId: number,
  reduceAmount: number,
  setLoading: (loading: boolean) => void,
  onSuccess?: () => void,
): Promise<boolean> => {
  try {
    setLoading(true);

    const res = await appApi.reduceInstallmentPaymentBankTransfer(
      installmentPlanId,
      installmentId,
      reduceAmount,
    );

    if (res.data.errCode) {
      toast.warn(displayErrorText(res.data.errCode));
      setLoading(false);
      return false;
    }

    const updatedUserDetails = await appApi.getUserStudentDetails(user.id);
    globalUserPage.studentDetails = updatedUserDetails.data.body;

    toast.success('התשלום הופחת בהצלחה');
    setLoading(false);
    onSuccess?.();
    return true;
  } catch (e) {
    console.error('Error reducing bank transfer installment payment:', e);
    toast.error('שגיאה בהפחתת התשלום');
    setLoading(false);
    return false;
  }
};
